<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/holidays/toevoegen')" class="pull-right"
                      v-can="'feestdagen aanpassen'">Feestdag toevoegen
            </b-button>
            <b-button @click="openImportModal" class="pull-right mr-2" v-can="'feestdagen aanpassen'">Importeren</b-button>
          </b-col>
        </b-row>
        <resource-index ref="resourceIndex" header="Feestdagen" endpoint="holidays" show-route="holidays.view"/>
      </div>
    </div>

    <b-modal id="import-holidays" ref="import-holidays" title="Feestdagen importeren">
      <p class="mb-4">
        Importeer feestdagen aan de hand van een excel document met daarin de volgende kolommen:
      </p>
      <ol>
        <li>Naam</li>
        <li>Datum feestdag</li>
        <li>Vervangende datum</li>
        <li>Deadline (optioneel)</li>
      </ol>
      <b-form id="upload-form" @submit.prevent="importFile">
        <b-form-file
          required
          v-model="file"
          :state="Boolean(file)"
          accept=".xls, .xlsx, .csv"
          placeholder="Kies of sleep een bestand..."
          drop-placeholder="Sleep het bestand..."
          :disabled="saveButtonDisabled"/>
      </b-form>
      <template #modal-footer>
        <b-button class="ml-0" @click.prevent="hideImportModal" :disabled="saveButtonDisabled">Annuleren</b-button>
        <b-button type="submit"  class="ml-auto" variant="primary" :disabled="saveButtonDisabled" form="upload-form">Importeer</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';
    import {uploadData} from "../../api";

    export default {
        name: 'holidays',
        components: {ResourceIndex},
        data() {
            return {
                saveButtonDisabled: false,
                file: undefined,
            }
        },
        methods: {
            reset() {
              const $resourceIndex = this.$refs.resourceIndex;
              if ($resourceIndex.resetFilters) $resourceIndex.resetFilters();
            },
            openImportModal() {
                this.$refs['import-holidays'].show()
            },
            hideImportModal() {
                // enable form elements
                this.saveButtonDisabled = false;
                // reset file input
                this.file = undefined;
                // hide modal
                this.$refs['import-holidays'].hide();
            },
            async importFile() {
                let data = new FormData();
                data.append('file', this.file);

                this.saveButtonDisabled = true;

                let response = await uploadData('holidays/import', data);

                if (response.status !== 200) {
                    this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren van de feestdagen`, {
                        title: 'Oeps...',
                        autoHideDelay: 5000,
                        variant: 'danger',
                    });
                } else {
                    this.$bvToast.toast(`Importeren van feestdagen is gelukt`, {
                      title: 'Succes',
                      autoHideDelay: 5000,
                      variant: 'success',
                    });
                }

                this.reset();
                this.saveButtonDisabled = false;
                this.file = undefined;
                this.hideImportModal();
            },
        },
    }
</script>
